import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    FaBalanceScale,
    FaCog,
    FaFileContract,
    FaHandHoldingUsd,
    FaHome,
    FaUserFriends,
    FaUserShield,
    FaUsers,
} from 'react-icons/fa';
import { LuReceipt } from 'react-icons/lu';
import '../Sidebar.css';
import { rolesMapping } from '../utils/RolesUtils';
import { hasAnyRole } from '../utils/TokenUtils';

function Sidebar({ openSidebar }) {
    const location = useLocation();
    const navigate = useNavigate();

    const items = [
        { icon: FaHome, label: 'Início', path: '/', roles: null },
        { icon: FaUserFriends, label: 'Equipe', path: '/colaboradores', group: 'Gestão', roles: [rolesMapping.admin, rolesMapping.colaboradores] },
        { icon: FaUsers, label: 'Clientes', path: '/clientes', group: 'Gestão', roles: [rolesMapping.admin, rolesMapping.clientes] },
        { icon: FaFileContract, label: 'Contratos', path: '/contratos', group: 'Gestão', roles: [rolesMapping.admin, rolesMapping.contratos] },
        { icon: FaHandHoldingUsd, label: 'Comissões', path: '/comissao', group: 'Financeiro', roles: [rolesMapping.admin, rolesMapping.comissao] },
        { icon: LuReceipt, label: 'Despesas', path: '/despesas', group: 'Financeiro', roles: [rolesMapping.admin, rolesMapping.despesas] },
        { icon: FaBalanceScale, label: 'Balanço', path: '/balancofinanceiro', group: 'Financeiro', roles: [rolesMapping.admin, rolesMapping.balancofinanceiro] },
        { icon: FaCog, label: 'Config. despesas', path: '/configdespesas', group: 'Sistema', roles: [rolesMapping.admin, rolesMapping.configdespesas] },
        { icon: FaUserShield, label: 'Usuários', path: '/admin/usuarios', group: 'Sistema', roles: [rolesMapping.admin] },
    ];

    const visibleItems = items.filter((item) => !item.roles || item.roles.some((role) => hasAnyRole(role)));
    const groups = ['Gestão', 'Financeiro', 'Sistema'];
    const isMappedRoute = visibleItems.some((item) => item.path !== '/' && location.pathname.startsWith(item.path));

    if (!isMappedRoute) return null;

    return (
        <aside className={`sidebar ${openSidebar ? 'sidebar-expanded' : ''}`} aria-label="Navegação principal">
            <nav className="sidebar-content">
                <ul className="sidebar-list">
                    {visibleItems.filter((item) => !item.group).map(({ icon: Icon, label, path }) => {
                        const isActive = path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);

                        return (
                            <li key={path}>
                                <button
                                    type="button"
                                    className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''}`}
                                    onClick={() => navigate(path)}
                                    aria-current={isActive ? 'page' : undefined}
                                    title={openSidebar ? undefined : label}
                                >
                                    <Icon className="sidebar-icon" aria-hidden="true" />
                                    {openSidebar && <span className="sidebar-label">{label}</span>}
                                </button>
                            </li>
                        );
                    })}
                    {groups.map((group) => {
                        const groupItems = visibleItems.filter((item) => item.group === group);
                        if (!groupItems.length) return null;

                        return (
                            <React.Fragment key={group}>
                                <li className="sidebar-group-title" aria-hidden="true">{group}</li>
                                {groupItems.map(({ icon: Icon, label, path }) => {
                                    const isActive = location.pathname.startsWith(path);

                                    return (
                                        <li key={path}>
                                            <button
                                                type="button"
                                                className={`sidebar-item ${isActive ? 'sidebar-item-active' : ''}`}
                                                onClick={() => navigate(path)}
                                                aria-current={isActive ? 'page' : undefined}
                                                title={openSidebar ? undefined : label}
                                            >
                                                <Icon className="sidebar-icon" aria-hidden="true" />
                                                {openSidebar && <span className="sidebar-label">{label}</span>}
                                            </button>
                                        </li>
                                    );
                                })}
                            </React.Fragment>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
}

export default Sidebar;
